import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import AffordableHousingProgramsDetails from '../../subdepartmentdetails/AffordableHousingPrograms'


function AffordableHousingPrograms() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Affordable Housing Programs || Housing and Community Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Housing"
            title="Affordable Housing Programs"
            subtitledown="Department of Housing & Community Development"
           />
            <AffordableHousingProgramsDetails/>
        </div>
    </>
  )
}

export default AffordableHousingPrograms